import React, { useEffect, useState } from 'react';
import Typed from "typed.js";
import {  FaMicroscope, FaVideo,FaNotesMedical, FaHospitalSymbol, FaUserMd, FaPills } from 'react-icons/fa';
import { GiHealthNormal,  } from "react-icons/gi";
import {  TbDeviceWatchStats,} from "react-icons/tb";
// import backgroundImage from '../../assests/medical-banner-with-doctor-wearing-face-mask.png';
// import backgroundImage from '../../assests/service/front-view-doctor-holding-heart.jpg';
import AutoScrollServices from './service';
import CelebrationGallery from './Celebration';
import Footer from '../../Component/Fooder';
import { motion } from "framer-motion"
import FutureHealthTech from './Feature';
import './global.css';
import { MdOutlineIntegrationInstructions } from 'react-icons/md';

export default function App() {
  useEffect(() => {
    const typed = new Typed(".typing-text", {
      strings: ["HIKEHEALTH GS"],
      typeSpeed: 100,
      backSpeed: 50,
      showCursor: false,
      loop: true,
    });

    return () => typed.destroy();
  }, []);

  // const contentBoxes = [
  //   { title: "Search Doctor", subtitle: "Choose your doctor from thousands of specialists.", icon: <TbUserSearch className="text-pink-500 text-4xl" />, bg: "from-[#be185d] to-[#2a627a]" },
  //   { title: "AI Healthcare", subtitle: "Transforming patient care with AI-powered insights.", icon: <FaBrain className="text-red-500 text-4xl" />, bg: "from-[#03ab3b] to-[#2a627a]" },
  //   { title: "Pharmacy Online", subtitle: "Order medicines with fast delivery.", icon: <GiMedicines className="text-amber-300 text-4xl" />, bg: "from-[#68217a] to-[#2a627a]" },
  //   { title: "Smart Diagnostics", subtitle: "AI-powered insights for early detection.", icon: <FaMicroscope className="text-blue-500 text-4xl" />, bg: "from-[#1e3a8a] to-[#2a627a]" },
  //   { title: "Virtual Consultations", subtitle: "Remote healthcare with specialists.", icon: <FaVideo className="text-teal-500 text-4xl" />, bg: "from-[#0d9488] to-[#2a627a]" },
  //   { title: "Emergency Care", subtitle: "Access 24/7 urgent care.", icon: <TbEmergencyBed className="text-red-800 text-4xl" />, bg: "from-[#a85858] to-[#2a627a]" },
  // ];
  const contentBoxes = [
    {
      title: "Clinical Systems & EHR Vendors",
      subtitle: "We help build and integrate clinical software, EHR, and medical workflow systems that align with HL7, FHIR, and industry standards for seamless interoperability and patient data sharing.",
      icon: <FaNotesMedical className="text-[#2a627a] text-4xl" />,
      bg: "bg-gradient-to-t from-transparent to-[#2a627a]",
    },
    {
      title: "Healthcare Providers & Payers",
      subtitle: "We support hospitals, clinics, and insurers by designing scalable, secure platforms that enhance operational efficiency and care delivery across the care continuum.",
      icon: <FaHospitalSymbol className="text-[#2a627a] text-4xl" />,
      bg: "bg-gradient-to-t from-transparent to-[#2a627a]",
    },
    {
      title: "Patients & Consumer Health Platforms",
      subtitle: "Empower patient-centric apps that improve accessibility, remote care, and health tracking—while maintaining privacy and HIPAA compliance.",
      icon: <FaUserMd className="text-[#2a627a] text-4xl" />,
      bg: "bg-gradient-to-t from-transparent to-[#2a627a]",
    },
    {
      title: "Pharmaceutical & Life Sciences",
      subtitle: "Assist pharma companies with digital transformation, from R&D data platforms to supply chain management and regulatory reporting systems.",
      icon: <FaPills className="text-[#2a627a] text-4xl" />,
      bg: "bg-gradient-to-t from-transparent to-[#2a627a]",
    },
    {
      title: "Telehealth & Virtual Care",
      subtitle: "Develop robust telemedicine platforms that enable secure, real-time interactions between providers and patients with integrated scheduling, video, and e-prescription systems.",
      icon: <FaVideo className="text-[#2a627a] text-4xl" />,
      bg: "bg-gradient-to-t from-transparent to-[#2a627a]",
    },
    {
      title: "AI & ML-Driven Diagnostics",
      subtitle: "Integrate AI solutions for clinical decision support, image analysis, patient triage, and early diagnosis with high accuracy and compliance.",
      icon: <GiHealthNormal className="text-[#2a627a] text-4xl" />,
      bg: "bg-gradient-to-t from-transparent to-[#2a627a]",
    },
    {
      title: "Healthcare Investors & Startups",
      subtitle: "Help investors validate tech feasibility, and assist startups with MVP development and architecture reviews for long-term scalability.",
      icon: <FaMicroscope className="text-[#2a627a] text-4xl" />,
      bg: "bg-gradient-to-t from-transparent to-[#2a627a]",
    },
    {
      title: "Smart Devices & Wearables",
      subtitle: "Build health tracking systems integrated with IoT and wearables, providing real-time monitoring and alerts for patients and care teams.",
      icon: <TbDeviceWatchStats className="text-[#2a627a] text-4xl" />,
      bg: "bg-gradient-to-t from-transparent to-[#2a627a]",
    },
    {
      title: "Interoperability & Compliance Services",
      subtitle: "Provide expertise in FHIR, HL7 v2/v3, CDA, and API integrations to ensure seamless data exchange between systems—while meeting HIPAA and GDPR standards.",
      icon: <MdOutlineIntegrationInstructions className="text-[#2a627a] text-4xl" />,
      bg: "bg-gradient-to-t from-transparent to-[#2a627a]",
    },
  ]; 
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    // Generate random particles
    const newParticles = Array.from({ length: 30 }, (_, index) => ({
      id: index,
      x: Math.random() * 100 + "vw",
      y: Math.random() * 100 + "vh",
      size: Math.random() * 8 + 3 + "px",
      duration: Math.random() * 6 + 4 + "s",
      delay: Math.random() * 2 + "s",
    }));
    setParticles(newParticles);
  }, []);

  return (
    <div className="relative w-full overflow-hidden">
      {/* <div
        id='Landing'
        className="relative flex flex-col justify-center items-center p-12 box-sizing-border bg-cover bg-center bg-fixed"
        style={{ backgroundImage: `url(${backgroundImage})`, minHeight: '100vh' }}
      > */}
      <div
        className="relative flex flex-col justify-center items-center p-12 min-h-screen overflow-hidden"
        style={{
          background: "radial-gradient(circle, #5A9BB5, #3C748C, #2a627a)"
        }}

      >
        {/* Subtle Background Glow */}
        <div className="absolute top-1/4 left-1/3 w-96 h-96 bg-blue-300 opacity-10 blur-3xl rounded-full"></div>
        <div className="absolute bottom-1/4 right-1/3 w-80 h-80 bg-green-300 opacity-10 blur-3xl rounded-full"></div>

        {/* Floating Particles */}
        {particles.map((particle) => (
          <div
            key={particle.id}
            className="absolute bg-[#2a627a] rounded-full opacity-60 animate-particle"
            style={{
              left: particle.x,
              top: particle.y,
              width: particle.size,
              height: particle.size,
              animationDuration: particle.duration,
              animationDelay: particle.delay,
            }}
          ></div>
        ))}

        {/* Main Content */}
        <div className="relative m-6 md:m-4 lg:m-16 font-[Poppins] text-white text-center font-bold">
  <p className="glitch text-glow text-4xl md:text-5xl lg:text-6xl">
    Welcome to <span className="text-green-400 typing-text"></span>
  </p>
  <p className="glitch text-glow text-sm md:text-base lg:text-lg mt-4" data-text="Your trusted partner in healthcare innovation.">
    Your trusted partner in healthcare innovation.
  </p>
  <p className="glitch text-glow text-sm md:text-base lg:text-lg mt-2" data-text="Join us in revolutionizing healthcare through AI-driven, compliant, and interoperable solutions!">
    Join us in revolutionizing healthcare through AI-driven, compliant, and interoperable solutions!
  </p>
</div>


        {/* Description Section */}
        <motion.div
        className="relative m-6 md:m-2 lg:m-10 text-white font-[Poppins] sm:text-sm md:text-lg lg:text-lg text-center w-full backdrop-blur-lg bg-white bg-opacity-10 p-6 rounded-lg shadow-xl border border-white border-opacity-20 text-explosion"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.2, delay: 0.5 }}
      >
        <p className="mx-8">
        We are committed to delivering advanced healthcare solutions that enhance patient care, ensure HIPAA compliance, and streamline clinical workflows using cutting-edge technologies like AI, HL7, and FHIR. Our expert team specializes in building secure, scalable systems that improve healthcare efficiency, accessibility, and data interoperability for providers and patients worldwide.
        </p>
      </motion.div>
        {/* <div className="relative m-6 md:m-2 lg:m-10 text-white font-[Poppins] sm:text-sm md:text-lg lg:text-lg text-center w-full text-explosion">
          <p className="mx-8">
            We are committed to providing advanced healthcare solutions that enhance patient care and streamline medical processes.
            With cutting-edge technology and a dedicated team, we strive to improve healthcare accessibility, efficiency, and effectiveness worldwide.
          </p>
        </div> */}

        {/* Wave Animation */}
      </div>

      {/* Services Section */}
      {/* <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 p-12 bg-gradient-to-l from-[#78ffa5] to-[#03ab3b]"> */}
      <div className='max-w-full mx-auto p-8 space-y-8 bg-white'>
        <h2 className="text-[24px] md:text-[30px] font-semibold text-center bg-gradient-to-l from-[#2a627a] text-gray-800 rounded-xl ">
          Who We Serve
        </h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 md:p-10 p-2">
          {contentBoxes.map((box, index) => (
            <motion.div
              key={index}
              className={`flex justify-center items-center h-auto bg-gradient-to-r ${box.bg} p-6 rounded-xl shadow-xl`}
              whileHover={{
                scale: 1.05,
                rotateY: 10,
                rotateX: 5,
                transition: { duration: 0.3 },
              }}
              whileTap={{ scale: 0.98 }}
              style={{ perspective: 1000 }} // Adds depth effect
            >
              <motion.div
                className="relative bg-white p-6  h-auto rounded-xl shadow-lg text-center"
                whileHover={{ rotateY: -10, rotateX: -5 }}
              >
                {/* 3D Floating Icon Effect */}
                <motion.div
                  className="flex justify-center mb-1"
                  whileHover={{
                    y: -20, // Moves the icon upwards (pops out)
                    scale: 1.2,
                    rotateX: 15,
                    rotateY: 10,
                    transition: { type: "spring", stiffness: 100 },
                  }}
                  style={{
                    position: "relative",
                    zIndex: 10, // Ensures the icon appears above the card
                    filter: "drop-shadow(0px 10px 10px rgba(0,0,0,0.2))", // Adds a floating shadow
                  }}
                >
                  {box.icon}
                </motion.div>

                <h2 className="text-lg font-bold text-[#2a627a]">{box.title}</h2>
                <p className="text-gray-800 text-sm mt-2">{box.subtitle}</p>
              </motion.div>
            </motion.div>
          ))}
        </div>
      </div>
      <div>
        <CelebrationGallery />
      </div>
      <div>
        <AutoScrollServices />
      </div>
      <div>
        <FutureHealthTech />
      </div>
      {/* Call to Action Section */}
      <div className="bg-gradient-to-r from-[#2a627a] to-[#03ab3b] text-white py-12 text-center">
        <h2 className="text-lg font-semibold">Join the Future of Healthcare</h2>
        <p className="mt-2 text-sm">Sign up now to experience seamless digital healthcare.</p>
        {/* <button className="mt-6 px-6 py-3 bg-white text-blue-600 rounded-lg font-semibold hover:bg-gray-100">Get Started</button> */}
      </div>

      {/* Footer */}
      <Footer />

    </div>
  );
}

        <div className="absolute bottom-0 left-0 w-full h-24 bg-wave"></div>